<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="true" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography">
  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

    <form [formGroup]="frmDialog" novalidate>
      @if (title) {
        <h2 class="tw:mb-2">{{ title }}</h2>
      }
      <h3><label>{{ label }}</label></h3>
      <textarea class="field__control" #comment stringFormatter cdkTextareaAutosize cdkAutosizeMinRows="1" formControlName="comment"
        cdkAutosizeMaxRows="5"></textarea>
      <span class="field__hint tw:block tw:text-right">{{comment.value?.length || 0}}/200</span>
      @if (frmDialog.controls.comment.invalid && frmDialog.controls.comment.touched) {
        <span class="field__error">Comment, characters should be between 20 and 200</span>
      }
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="justify">
  <div><button mat-dialog-close input type="button" [mat-dialog-close]="true"
  class="btn btn-primary divclose">Cancel</button></div>
  <div><button class="btn btn-primary" cdkFocusInitial [disabled]="frmDialog.invalid" (click)="Confirm();">Confirm</button></div>
</mat-dialog-actions>
